import * as _ from "lodash/fp";
import { stringSlice } from "./string-slice";

export const fp = {
  ..._,
  stringSlice
};
